import { render } from "./App.vue?vue&type=template&id=ac5fc8d0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ac5fc8d0&lang=css"

import exportComponent from "/Users/adamchaarawi/Desktop/dev/adams-personal-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__